import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.697 2.387a.667.667 0 0 0-.537 1.135c.26.26.26.682 0 .942L9.85 5.776a.667.667 0 1 1-.943-.943l.92-.92a1.999 1.999 0 1 1 3.718-1.444 2 2 0 1 1-1.441 3.719l-.823.823a.667.667 0 1 1-.943-.943l1.213-1.214a.667.667 0 0 1 .943 0 .666.666 0 1 0 .471-1.138.666.666 0 0 1-.667-.666.67.67 0 0 0-.601-.663M4.562 6.747c.956.383 2.012 1.108 2.972 2.067S9.218 10.83 9.6 11.785c.191.477.309.96.306 1.41-.003.453-.132.921-.487 1.276s-.823.483-1.276.486c-.45.003-.932-.115-1.409-.305-.955-.382-2.012-1.107-2.971-2.067-.96-.959-1.685-2.016-2.067-2.971-.19-.477-.308-.959-.305-1.409.003-.454.132-.922.486-1.277m1.286.847c-.219.002-.307.06-.342.096s-.095.125-.097.343c-.001.223.06.528.21.905.3.75.908 1.66 1.772 2.523.862.863 1.772 1.472 2.523 1.772.377.15.683.211.905.21.218-.001.307-.06.342-.096s.095-.124.096-.343c.002-.222-.059-.528-.21-.905-.3-.75-.908-1.66-1.771-2.523S4.818 8.286 4.067 7.985c-.376-.15-.682-.211-.904-.21",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.827 9.912c.26-.26.682-.26.943 0l.666.666a.667.667 0 1 1-.942.943l-.667-.667a.667.667 0 0 1 0-.942",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.533 4.376c1.598-.282 3.194.03 4.3 1.138 1.108 1.107 1.42 2.703 1.139 4.301-.283 1.6-1.166 3.27-2.553 4.656a.666.666 0 1 1-.943-.943c1.217-1.217 1.953-2.645 2.182-3.944.23-1.303-.052-2.412-.767-3.127S8.067 5.46 6.764 5.69c-1.3.23-2.727.965-3.943 2.182a.667.667 0 0 1-.944-.943c1.387-1.386 3.055-2.27 4.656-2.552",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })